import _extends from "/src/main/react/node_modules/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/images/ImageGrid.js";
import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router-dom";
import { Checkbox, FormControlLabel, FormGroup, Grid, GridList, GridListTile, LinearProgress, MenuItem, Select, Typography, FormControl, InputLabel, Input } from '@material-ui/core';
import ImageCard from './ImageCard';
import Util from "../../util/Util";
import { AUDIT_STATUS, BASE_URIS, ID_SPACE, IMAGE_DISPLAY_MODE, IMAGEGRID_QUALIFIERS as QUALS, PUBLISH_STATUS, Q_STRING, SORT_FIELD, TPIS_PARAMS, ASPECT_RATIO, LOCAL_STORAGE_ITEM_NAMES } from "../domain/constants";
import { Pagination } from "../common";
import queryString from "query-string";
import { setUpPageInfoFromQueryString, determinePageSize, determineSortInfoFromQueryString, changeSearchValue, setUpSortInfoFromQueryString, retrieveFromQueryString, setUpRatioFromQueryString, determineRatio, determineSelectedFilters, listToUrlString, setUpFiltersFromQueryString } from "../../util/QueryStringUtil";
import { retrieveUserPreferenceFromLocalStorage, storeUserPreferenceInLocalStorage } from "../../util/StorageUtil";
import { isNotABlankString, stringToList } from "../../util/StringUtil";
import SortsAndFilters from "../common/SortsAndFilters";
import { loadDisplayInfo } from "../../util/APIUtil";
const styles = theme => ({
  imageGrid: {
    padding: 8 * 3,
    margin: 10,
    display: 'flex',
    justifyContent: 'center'
  },
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    width: '80%'
  },
  formControl: {
    margin: theme.spacing(1),
    maxWidth: 300
  }
});
class ImageGrid extends Component {
  constructor(props) {
    super(props);
    /**
     * Handles generic field changes
     *
     * Have to forceUpdate because of the way setState works: https://reactjs.org/docs/react-component.html#setstate
     */
    _defineProperty(this, "handleChange", name => event => {
      let value = event.target.value;
      this.state[name] = value;
      let qStringParamName = null;
      let localStorageName = null;
      if ('ratio' === name) {
        qStringParamName = Q_STRING.RATIO;
        localStorageName = LOCAL_STORAGE_ITEM_NAMES.preferredAspectRatio;
      } else if ('specialSelectionRule' === name) {
        qStringParamName = Q_STRING.RULE;
      }
      if (qStringParamName != null) {
        // selectedFilters comes out in an Array
        if (Array.isArray(value)) {
          value = listToUrlString(value);
        }
        changeSearchValue(qStringParamName, value, this.props);
      }
      if (localStorageName != null) {
        storeUserPreferenceInLocalStorage(localStorageName, value);
      }
      this.reset();
      this.forceUpdate();
    });
    const querystringValues = queryString.parse(this.props.location.search);
    const pageSize = determinePageSize(querystringValues, props);
    const sortInfo = determineSortInfoFromQueryString(querystringValues, props);
    const ratio = determineRatio(querystringValues, props);
    const selectedFilters = determineSelectedFilters(querystringValues, props);
    const selectionRules = retrieveUserPreferenceFromLocalStorage(LOCAL_STORAGE_ITEM_NAMES.specialSelectionRules);
    const specialSelectionRule = retrieveUserPreferenceFromLocalStorage(LOCAL_STORAGE_ITEM_NAMES.defaultSpecialSelectionRule);
    const allSelectionRules = selectionRules != null ? stringToList(selectionRules) : [];
    this.state = {
      loaded: false,
      items: [],
      // never set this to null
      totalElements: 0,
      page: 0,
      totalPages: 0,
      allFilters: [],
      allSelectionRules: allSelectionRules,
      specialSelectionRule: specialSelectionRule != null ? specialSelectionRule : allSelectionRules.length > 0 ? allSelectionRules[0] : '',
      selectedFilters: selectedFilters,
      morePages: true,
      pageSize: pageSize,
      baseUri: props.baseUri != null ? props.baseUri : null,
      allowSort: props.allowSort != null ? props.allowSort : true,
      sortField: sortInfo.field,
      sortDescending: sortInfo.desc,
      ratio: ratio,
      qualifier: props.qualifier != null ? props.qualifier : QUALS.all,
      mode: IMAGE_DISPLAY_MODE.BY_ASSOCIATION
    };
    loadDisplayInfo(this);
    this.loadContent();
    this.gridRef = React.createRef();
  }

  /**
   * Clears and reloads the content that was loaded according to the previous parameters
   */
  reset() {
    this.state.loaded = false;
    this.state.items = [];
    this.state.page = 0;
    this.state.totalPages = 0;
    this.state.morePages = true;
    this.totalElements = 0;
    this.loadContent();
    loadDisplayInfo(this);
  }
  /**
   * This gets called when you navigate back to this page from another page, and consequently you will need
   * to set everything up again from the queryString
   */
  componentDidUpdate(prevProps, prevState, snapshot) {
    setUpPageInfoFromQueryString(this);
    if (this.state.allFilters === []) loadDisplayInfo(this);
    const querystringValues = queryString.parse(this.props.location.search);
    const ratio = retrieveFromQueryString(Q_STRING.RATIO, querystringValues);
    setUpRatioFromQueryString(this, prevState, ASPECT_RATIO.THREE_BY_FOUR, querystringValues, ratio);
    const sortInfo = determineSortInfoFromQueryString(querystringValues, this.props);
    setUpSortInfoFromQueryString(this, prevState, SORT_FIELD.title, false, sortInfo, querystringValues);
    const filters = retrieveFromQueryString(Q_STRING.FILTERS, querystringValues);
    setUpFiltersFromQueryString(this, prevState, querystringValues, filters);
  }

  /**
   * Force the page to query for images to display.
   * These should automatically populate the Grid below
   */
  loadContent() {
    if (this.state.baseUri === null) {
      Util.log('ImageGrid.loadContent', true, 'ImageGrid somehow has a null baseUri value', false);
      return;
    }
    this.state.items = [];
    const uri = this.makeUri();
    if (this.state.loaded === true) {
      this.state.loaded = false; // react batches setState calls so we can't call setState here
      this.state.morePages = true; // don't display "there are no more images" during the load
      this.forceUpdate(); // force update to display loading bar
    }
    let items = [];
    Util.fetchWithRedirect(uri, 'GET', this.props).then(result => {
      let newItems = result.content;
      if (newItems != null) {
        newItems.forEach(item => {
          try {
            if (QUALS.orphaned === this.state.qualifier) {
              items.push(ImageGrid.imageCardItemFromOrphan(item, this));
            } else if (BASE_URIS.listImages === this.state.baseUri) {
              items.push(ImageGrid.imageCardItemFromImage(item, this));
            } else if (BASE_URIS.listAssociations === this.state.baseUri) {
              items.push(ImageGrid.imageCardItemFromAssociation(item, this));
            } else {
              items.push(ImageGrid.imageCardItemFromProgram(item, this));
            }
          } catch (e) {
            Util.log('ImageGrid.loadContent', true, e, false);
          }
        });
      }
      this.setState({
        loaded: true,
        items: items,
        totalPages: result.totalPages,
        morePages: !result.last,
        totalElements: result.totalElements
      });
    }).catch(e => {
      Util.log('ImageGrid.loadContent', true, e, false);
      this.setState({
        loaded: true,
        e
      });
    });
  }
  makeUri() {
    let uri = BASE_URIS.prefix + this.state.baseUri + "?".concat(TPIS_PARAMS.PAGE, "=") + this.state.page + "&".concat(TPIS_PARAMS.PAGE_SIZE, "=") + this.state.pageSize + "&".concat(TPIS_PARAMS.SORT_FIELD, "=") + this.state.sortField + "&".concat(TPIS_PARAMS.SORT_DESC, "=") + this.state.sortDescending;

    // Add status filters
    if (QUALS.audit === this.state.qualifier) {
      uri += TPIS_PARAMS.AUDIT_PENDING;
    } else if (QUALS.approved === this.state.qualifier) {
      uri += TPIS_PARAMS.AUDIT_ACCEPTED;
    } else if (QUALS.rejected === this.state.qualifier) {
      uri += TPIS_PARAMS.AUDIT_REJECTED;
    } else if (QUALS.publish === this.state.qualifier) {
      uri += TPIS_PARAMS.PUBLISH_PENDING;
    } else if (QUALS.published === this.state.qualifier) {
      uri += TPIS_PARAMS.PUBLISHED;
    } else if (QUALS.publishFailed === this.state.qualifier) {
      uri += TPIS_PARAMS.PUBLISH_FAILED;
    }

    // always include both images and associations
    if (this.state.baseUri === BASE_URIS.listImages) {
      uri += TPIS_PARAMS.INCLUDE_ASSOCIATIONS;
    } else if (this.state.baseUri === BASE_URIS.listAssociations) {
      uri += TPIS_PARAMS.INCLUDE_IMAGE;
    }

    // filters
    if (this.state.selectedFilters != null && this.state.selectedFilters.length > 0) {
      uri += "&".concat(TPIS_PARAMS.FILTERS, "=").concat(this.state.selectedFilters);
    }
    return uri;
  }
  render() {
    const classes = this.props.classes;
    const _this$state = this.state,
      qualifier = _this$state.qualifier,
      sortField = _this$state.sortField,
      sortDescending = _this$state.sortDescending,
      allowSort = _this$state.allowSort,
      allFilters = _this$state.allFilters,
      selectedFilters = _this$state.selectedFilters,
      ratio = _this$state.ratio,
      allSelectionRules = _this$state.allSelectionRules,
      specialSelectionRule = _this$state.specialSelectionRule;
    const key = "".concat(qualifier).concat(sortField).concat(sortDescending);
    return /*#__PURE__*/React.createElement(Fragment, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 215,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: 'row',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      wrap: 'nowrap',
      style: {
        marginTop: '1vh',
        minWidth: '80vw'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 216,
        columnNumber: 17
      }
    }, allowSort && SortsAndFilters(this, classes), /*#__PURE__*/React.createElement(Grid, {
      md: 8,
      item: true,
      container: true,
      direction: 'row',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 220,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 222,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 223,
        columnNumber: 29
      }
    }, "Ratio:")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 225,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 226,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Select, {
      id: "aspect-ratio-select",
      value: ratio,
      onChange: this.handleChange('ratio'),
      input: /*#__PURE__*/React.createElement(Input, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 228,
          columnNumber: 121
        }
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 227,
        columnNumber: 33
      }
    }, Object.keys(ASPECT_RATIO).map(aspectRatio => /*#__PURE__*/React.createElement(MenuItem, {
      value: ASPECT_RATIO[aspectRatio],
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 230,
        columnNumber: 41
      }
    }, ASPECT_RATIO[aspectRatio])))))), allSelectionRules != null && Array.isArray(allSelectionRules) && allSelectionRules.length > 0 && /*#__PURE__*/React.createElement(Grid, {
      md: 8,
      item: true,
      container: true,
      direction: 'row',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      wrap: 'nowrap',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 237,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 239,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 240,
        columnNumber: 29
      }
    }, "Rule:")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 242,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 243,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Select, {
      id: "selection-rule-select",
      value: specialSelectionRule,
      onChange: this.handleChange('specialSelectionRule'),
      input: /*#__PURE__*/React.createElement(Input, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 246,
          columnNumber: 44
        }
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 244,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      value: '',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 247,
        columnNumber: 37
      }
    }, "NONE"), allSelectionRules.map(rule => /*#__PURE__*/React.createElement(MenuItem, {
      value: rule,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 249,
        columnNumber: 41
      }
    }, rule))))))), Pagination(this.state, this, classes, true), /*#__PURE__*/React.createElement(GridList, {
      key: key,
      id: this.getName(),
      cellHeight: "auto",
      spacing: 8,
      cols: 5,
      ref: this.gridRef,
      className: classes.imageGrid,
      style: {
        maxHeight: '60vh',
        minHeight: '50vh',
        overflow: 'auto'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 259,
        columnNumber: 17
      }
    }, this.state.items != null && this.state.items.length > 0 && this.state.items.map(item => /*#__PURE__*/React.createElement(GridListTile, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 262,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(ImageCard, _extends({
      key: item.index
    }, item, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 263,
        columnNumber: 29
      }
    }))))), !this.state.morePages && /*#__PURE__*/React.createElement(TabContainer, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 268,
        columnNumber: 17
      }
    }, "There are no more items to load"), this.state.loaded === false && /*#__PURE__*/React.createElement(LinearProgress, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 271,
        columnNumber: 17
      }
    }), this.state.loaded === true && this.state.totalPages > 0 && (this.state.items == null || this.state.items.length === 0) && /*#__PURE__*/React.createElement(TabContainer, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 274,
        columnNumber: 17
      }
    }, "There are no assets for this provider"), Pagination(this.state, this, classes, false));
  }
  static isAnAuditQualifier(qualifier) {
    switch (qualifier) {
      case QUALS.audit:
      case QUALS.approved:
      case QUALS.rejected:
        return true;
      default:
        return false;
    }
  }
  static hasAuditPendingImages(item, instance) {
    const qualifier = instance.state.qualifier;
    if (qualifier === QUALS.audit) {
      // If it's an audit page, they all obviously do require audit
      return true;
    } else if (qualifier !== QUALS.approved && qualifier !== QUALS.rejected) {
      const images = item.images;
      if (images != null && images.length > 0) {
        for (const image of images) {
          if (image.auditStatus != null && image.auditStatus === AUDIT_STATUS.pending) {
            return true;
          }
        }
      }
    }
    return false;
  }
  static hasPublishPendingImages(item, instance) {
    const qualifier = instance.state.qualifier;
    if (qualifier === QUALS.publish) {
      // If it's the publish pending page, there is hopefully an image pending publish
      return true;
    } else {
      const images = item.images;
      if (images != null && images.length > 0) {
        for (const image of images) {
          if (image.auditStatus != null && image.auditStatus === AUDIT_STATUS.accepted && image.publishStatus != null && image.publishStatus === PUBLISH_STATUS.pending) {
            return true;
          }
        }
      }
    }
    return false;
  }
  static hasPendingAssociations(item, instance) {
    const qualifier = instance.state.qualifier;
    if (qualifier === QUALS.all) {
      const associations = item.associations;
      if (associations != null) {
        for (const association of associations) {
          if (association.auditStatus != null && association.auditStatus === AUDIT_STATUS.pending) {
            return true;
          }
        }
      }
    }
    return false;
  }
  static hasPublishFailedImages(item) {
    const images = item.images;
    if (images != null && images.length > 0) {
      for (const image of images) {
        if (image.publishStatus != null && image.publishStatus === PUBLISH_STATUS.failed) {
          return true;
        }
      }
    }
    return false;
  }
  static hasPublishFailedAssociations(item) {
    const associations = item.associations;
    if (associations != null) {
      for (const association of associations) {
        if (association.publishStatus != null && association.publishStatus === PUBLISH_STATUS.failed) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * The root object of the listPrograms call is a program with its related images and associations. This method reshapes it to use with an ImageCard
   * @returns {{merlinId: *, adiId: (string|*), imageURL: string, hasAuditPendingImages: boolean, title: *, orphan: boolean, hasPendingAssociations: boolean}}
   */
  static imageCardItemFromProgram(program, instance) {
    let _instance$state = instance.state,
      ratio = _instance$state.ratio,
      specialSelectionRule = _instance$state.specialSelectionRule;

    // default should be handled by now, but just in case
    if (ratio === null || ratio === '') {
      ratio = "3x4";
    }
    let myriadBaseUrl = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.myriadBaseUrl);
    if (myriadBaseUrl == null || myriadBaseUrl === '') {
      // use prod if anything happens with localStorage
      myriadBaseUrl = "https://myriad.merlin.comcast.com";
    }
    const selectedPartner = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.selectedPartner);
    let url = "".concat(myriadBaseUrl, "/select/image?entityId=").concat(program.id, "&ratio=").concat(ratio, "&height=300&default=true&partnerIdentifier=").concat(selectedPartner);
    if (isNotABlankString(specialSelectionRule)) {
      url += "&rule=".concat(specialSelectionRule);
    }
    return {
      title: program.title,
      subtitle: program.type === "Episode" ? program.episodeTitle : program.type === "SportingEvent" ? program.sportsSubtitle : null,
      adiId: program.assets != null && program.assets.length > 0 && program.assets[0].mediaGuid != null ? program.assets[0].mediaGuid : null,
      allAdiIds: ImageGrid.getAllAdiIds(program, objType.PROGRAM),
      imageURL: url,
      merlinId: program.id,
      merlinResourceType: program.merlinResourceType,
      hasAuditPendingImages: ImageGrid.hasAuditPendingImages(program, instance),
      hasPendingAssociations: ImageGrid.hasPendingAssociations(program, instance),
      hasPublishPendingImages: ImageGrid.hasPublishPendingImages(program, instance),
      hasPublishFailedImages: ImageGrid.hasPublishFailedImages(program),
      hasPublishFailedAssociations: ImageGrid.hasPublishFailedAssociations(program),
      orphan: false,
      normalized: true,
      type: program.type,
      ratio: instance.state.ratio
    };
  }

  /**
   * The root object of the listOrphans call has a child image and a child association. This method reshapes it to use with an ImageCard
   * @returns {{associations: *, images: *, adiId: string, imageURL: (*|string), orphan: boolean}}
   */
  static imageCardItemFromOrphan(orphan, instance) {
    let orphanItem = {
      adiId: orphan.association != null ? orphan.association.entityId : '',
      allAdiIds: ImageGrid.getAllAdiIds(orphan, objType.ORPHAN),
      imageURL: orphan.image.url,
      orphan: true,
      merlinResourceType: null,
      images: orphan.image != null ? [orphan.image] : [],
      associations: orphan.association != null ? [orphan.association] : [],
      normalized: false,
      ratio: instance.state.ratio
    };

    // These two depend on orphanItem.images and orphanItem.associations
    orphanItem.displayTitle = orphanItem.adiId;
    orphanItem.hasAuditPendingImages = ImageGrid.hasAuditPendingImages(orphanItem, instance);
    orphanItem.hasPendingAssociations = ImageGrid.hasPendingAssociations(orphanItem, instance);
    orphanItem.hasPublishPendingImages = ImageGrid.hasPublishPendingImages(orphanItem, instance);
    orphanItem.hasPublishFailedImages = ImageGrid.hasPublishFailedImages(orphanItem);
    orphanItem.hasPublishFailedAssociations = ImageGrid.hasPublishFailedAssociations(orphanItem);
    return orphanItem;
  }

  /**
   * The root object of the listImages call is an image (with associations shown). This method reshapes it to use with an ImageCard
   * @returns {{associations: *, images: {auditStatus: *, id: *, publishStatus: *}[], merlinId: *, adiId: *, imageURL: *, orphan: boolean}}
   */
  static imageCardItemFromImage(image, instance) {
    let imageObj = {
      id: image.id,
      auditStatus: image.auditStatus,
      publishStatus: image.publishStatus
    };
    let imageItem = {
      imageURL: image.url,
      adiId: ImageGrid.determineIdFromObject(image, null),
      allAdiIds: ImageGrid.getAllAdiIds(image, objType.IMAGE),
      merlinId: ImageGrid.determineIdFromObject(image, ID_SPACE.MERLIN),
      images: [imageObj],
      merlinResourceType: null,
      associations: image.associations != null ? image.associations : [],
      orphan: false,
      normalized: false,
      ratio: instance.state.ratio
    };

    // these depend on associations being set on the imageItem
    imageItem.displayTitle = imageItem.adiId;
    imageItem.hasAuditPendingImages = ImageGrid.hasAuditPendingImages(imageItem, instance);
    imageItem.hasPendingAssociations = ImageGrid.hasPendingAssociations(imageItem, instance);
    imageItem.hasPublishPendingImages = ImageGrid.hasPublishPendingImages(imageItem, instance);
    imageItem.hasPublishFailedImages = image.publishStatus === PUBLISH_STATUS.failed;
    imageItem.hasPublishFailedAssociations = ImageGrid.hasPublishFailedAssociations(imageItem);
    if (imageItem.adiId === null && imageItem.merlinId === null) {
      imageItem.canLinkToEntity = false;
    }
    return imageItem;
  }
  static imageCardItemFromAssociation(association, instance) {
    const image = association.image;
    const imageObj = {
      id: image.id,
      auditStatus: image.auditStatus,
      publishStatus: image.publishStatus
    };
    return {
      displayTitle: association.entityId,
      imageURL: image.url,
      adiId: association.entityProvider !== ID_SPACE.MERLIN ? association.entityId : null,
      allAdiIds: association.entityProvider === ID_SPACE.ADI ? [association.entityId] : [],
      merlinId: association.entityProvider === ID_SPACE.MERLIN ? association.entityId : null,
      images: [imageObj],
      merlinResourceType: null,
      orphan: false,
      normalized: false,
      hasAuditPendingImages: imageObj.auditStatus === AUDIT_STATUS.pending,
      hasPendingAssociations: association.auditStatus === AUDIT_STATUS.pending,
      hasPublishPendingImages: imageObj.auditStatus === AUDIT_STATUS.pending && imageObj.publishStatus === PUBLISH_STATUS.pending,
      hasPublishFailedImages: imageObj.publishStatus === PUBLISH_STATUS.failed,
      hasPublishFailedAssociations: association.publishStatus === PUBLISH_STATUS.failed,
      ratio: instance.state.ratio
    };
  }
  static determineIdFromObject(image, idSpace) {
    if (image.associations != null && image.associations.length > 0) {
      for (let a of image.associations) {
        if (idSpace != null && a.entityProvider.toLowerCase() === idSpace.toLowerCase() || idSpace == null && a.entityProvider.toLowerCase() !== ID_SPACE.MERLIN) {
          return a.entityId;
        }
      }
    }
    return null;
  }
  static getAllAdiIds(object, objType) {
    let associations = objType.ORPHAN !== objType ? object.associations : [object.association];
    const adiIds = [];
    if (objType.PROGRAM === objType) {
      let assets = object.assets;
      if (assets != null && assets.length > 0) {
        // programs may not have associations, but if they have any ADI ids associated to them, they will be represented by an asset object on the parent
        assets.map(asset => {
          if (asset.mediaGuid != null && asset.mediaGuid !== '') {
            adiIds.push(asset.mediaGuid);
          }
        });
      }
    } else {
      if (associations != null && associations.length > 0) {
        associations.map(association => {
          if (association.entityProvider !== ID_SPACE.MERLIN && association.entityId != null) {
            adiIds.push(association.entityId);
          }
        });
      }
    }
    return adiIds;
  }
  getName() {
    return 'imagegrid-' + this.state.qualifier;
  }
}
const objType = {
  ORPHAN: 'ORPHAN',
  PROGRAM: 'PROGRAM',
  IMAGE: 'IMAGE'
};
function TabContainer(props) {
  return /*#__PURE__*/React.createElement(Typography, {
    align: 'center',
    component: "div",
    style: {
      padding: 8 * 3
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 606,
      columnNumber: 9
    }
  }, props.children);
}
export default withStyles(styles)(withRouter(ImageGrid));